module.exports = __webpack_public_path__ + "img/caag1030_account.b0ff8f51.png";